export const ERROR_TYPE = {
    REQUIRED: 'required',
    INVALID: 'invalid',
    NONE: 'none',
};

export const Constants = {
    events: [
        { id: 1, name: 'Program' },
        { id: 2, name: 'Series' },
        { id: 3, name: 'Season' },
        { id: 4, name: 'Title Group' },
        { id: 5, name: 'None' }
    ],
    defaultBreakPatternData: {
        type: '',
        slotPosition: '',
        optional: false,
        priority: 0,
        selection: '',
        eventName: '',
        externalID: '',
        position: 0,
        assetID: null,
        id: crypto.randomUUID(),
    },
    defaultSegmentPositions: [
        ...Array.from({ length: 20 }, (_, i) => `${i + 1}`),
        'All But Last Segment',
        'Before Asset',
        'First Segment',
        'Last Segment',
        'Odd Segments',
        'Even Segments',
        'All Segments',
        'Middle Segment',
        'After Asset',
    ],
    defaultSelectionOptions: [
        'Rotation',
        'Shuffle',
        'Prevent Breaks',
    ],
    defaultFormErrors: {
        contentLevel: {
            eventName: '',
            eventType: '',
        },
        breakChannelTypes: {
            errorMessage: '',
            rowErrors: [],
        },
        hasErrors: false,
        versionName: '',
    },
}
